import { redirectToUrl } from "../../../utils/url/urlUtils";

export function sendCarriageResetConfigurator(productCode: string): void {
  redirectToUrl(`/carriages/${productCode}/carriagesConfiguratorPage/reset`);
}
